import { useCallback, useEffect, useState } from "react";
import { Box, Grid2 as Grid, Typography } from "@mui/material";
import LoadingOverlay from "../../../../components/Shared/LoadingOverlay/index";
import { useDashboardDataStore } from "../../../../config/advertiser.stores";
import adService from "../../../../services/ad.service";
import {
    CampaignCountWidget,
    CampaignPreviewsWidget,
    OnboardingWidget,
    PromoWidget,
    WebsitesLinkedWidget
} from "../../../../components/Advertiser/Widgets/index";
import { User } from "../../../../types/user";

const AdvertiserDashboard = ({ user }: { user: User }) => {
    const [isLoading, setIsLoading] = useState(false);
    const dashboardData = useDashboardDataStore((state) => state.dashboardData);
    const setDashboardData = useDashboardDataStore((state) => state.setDashboardData);

    const fetchData = useCallback(async () => {
        setIsLoading(true);
        const response = await adService.queryAll();
        setIsLoading(false);
        setDashboardData(response);
    }, [setDashboardData]);

    const getActiveCount = useCallback(() => {
        return dashboardData.filter((campaign) => campaign.adStatus === "active").length;
    }, [dashboardData]);

    const getTotalCount = useCallback(() => {
        return dashboardData.filter((campaign) => {
            const adStatus = campaign.adStatus;
            return adStatus === "active" || adStatus === "disabled";
        }).length;
    }, [dashboardData]);

    const getLinks = useCallback(() => {
        return [...new Set(dashboardData.map((campaign) => campaign.link).filter((link) => link !== null))];
    }, [dashboardData]);

    useEffect(() => {
        if (dashboardData.length === 0) {
            fetchData();
        }
        // eslint-disable-next-line
    }, []);

    return (
        <Box sx={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'left',
            gap: 3,
            margin: 3
        }}>
            <LoadingOverlay open={isLoading} />
            <Box display="flex">
                <Typography variant="h5">Welcome, {user.businessName}</Typography>
            </Box>
            <Grid container spacing={2} width="100%" minWidth="800px">
                {dashboardData.length === 0 ? (
                    !isLoading && <OnboardingWidget type="advertiser" />
                ) : (
                    <>
                    <CampaignPreviewsWidget campaigns={dashboardData} />
                    <WebsitesLinkedWidget links={getLinks()}/>
                    <PromoWidget />
                    <CampaignCountWidget active={getActiveCount()} total={getTotalCount()} />
                    </>
                )}
            </Grid>
        </Box>
    )
}

export default AdvertiserDashboard;
